@if (error) {
  <app-error-page
    [heading]="error.heading"
    [message]="error.message"
    [operationId]="error.operationId">
  </app-error-page>
} @else {
  <app-header [showHelpButton]="true" [showVisDetaljer]="false"></app-header>
  <main class="main-content">
    @if (ticketData; as ticketData) {
      @if (localeKey$ | async; as locale) {
        <div class="ticket-title-container">
          <h1 class="ticket-title">
            {{ utility.getLocalizedText(ticketData.name, locale) }}
          </h1>
          <p class="ticket-subtitle">
            {{  utility.getLocalizedText(ticketData.description, locale) }}
          </p>
        </div>
        <app-contact-card class ="card"></app-contact-card>
        <app-passenger-types class ="card" [locale] = 'locale'></app-passenger-types>
        <app-date-card class ="card" [locale] = 'locale'></app-date-card>
        @if (ticketData?.validityText) {
          <app-info-card
            [message]="utility.getLocalizedText(ticketData.validityText, locale)">
          </app-info-card>
        }
        <app-terms-card class ="card"></app-terms-card>
        <app-purchase-footer [locale] = 'locale'></app-purchase-footer>
      }
    }
  </main>
}

